import React from 'react';

export const Filter = () => (
    <path d='M23.952,0.287C23.87,0.112,23.693,0,23.5,0h-23C0.307,0,0.13,0.112,0.048,0.287C-0.035,0.462-0.009,0.67,0.114,0.819
			L10,12.771V23.5c0,0.202,0.122,0.385,0.309,0.462C10.37,23.988,10.436,24,10.5,24c0.13,0,0.258-0.051,0.354-0.146l3-3
			C13.947,20.76,14,20.633,14,20.5v-7.729l9.886-11.952C24.009,0.67,24.035,0.462,23.952,0.287z M13.114,12.271
			C13.041,12.361,13,12.474,13,12.59v7.703l-2,2V12.59c0-0.116-0.041-0.229-0.114-0.319L1.562,1h20.875L13.114,12.271z' />
);